import { render, staticRenderFns } from "./SelectGenreModal.vue?vue&type=template&id=2f20268c&"
import script from "./SelectGenreModal.vue?vue&type=script&lang=ts&"
export * from "./SelectGenreModal.vue?vue&type=script&lang=ts&"
import style0 from "./SelectGenreModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports